import { UAContext } from '@quentin-sommer/react-useragent';
import cn from 'classnames';
import React, { useContext } from 'react';
import Typography from '~components/typography';
import styles from './tabPane.module.scss';

interface ITabPaneProps {
  tab: string;
  active?: boolean;
}

const TabPane: React.FC<ITabPaneProps> = ({ tab, active }) => {
  const uaResults = useContext(UAContext).uaResults as UAResults;
  const isMobile = uaResults.mobile;
  return (
    <div className={cn(styles.wrapper, { [styles.selected]: active })}>
      <Typography
        variant={isMobile ? 'body3' : 'body2'}
        color={active ? 'var(--color-white)' : 'var(--color-purple_6)'}
      >
        {tab}
      </Typography>
    </div>
  );
};

export default TabPane;
